import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { PATIENT_ENGAGEMENT_STATUS_CSV_REPORT } from 'services/dataService/resources';
import common from 'constants/common';
import { showResult } from 'infrastructure/hooks/utils';

import { apiUrlGenerator } from '../use-api';

import type { TPatientEngagementReportFilter } from './types';

/**
 * Kicks off the CSV export. The whole filtered population can be large, so the
 * backend generates the file asynchronously and delivers a signed URL by email
 * (all stages) plus an in-app download link over WebSocket (non-prod). The
 * request just triggers the job and returns `201 { response: 'created' }`.
 */
export const useDownloadPatientEngagementReport = () => {
  const { mutate, isLoading } = useMutation({
    mutationFn: async (filter: TPatientEngagementReportFilter) =>
      downloadReport(filter),
  });

  return { download: mutate, isLoading };
};

const downloadReport = async (filter: TPatientEngagementReportFilter) => {
  const url = apiUrlGenerator(PATIENT_ENGAGEMENT_STATUS_CSV_REPORT, {
    clinicGuid: filter.clinicGuid,
    parentClinicGuid: filter.parentClinicGuid,
    doctorGuid: filter.doctorGuid,
    status: filter.status,
    patientGuid: filter.patientGuid,
    engagementAttempts: filter.engagementAttempts,
  });

  const { error } = await dataService.getList<{ response: string }>(url);
  showResult(error, error ? undefined : common.submitSuccessTypes.sendReport);
};
